module.exports = __webpack_public_path__ + "img/能源流向.4bb88d93.png";